<template>
  <div class="flex">
    <AdminPanel>
      <h1 class="mb-4">Setup Fee</h1>
      <div class="mx-4 flex flex-col">
        <div :key="key" v-for="key in Object.keys(tiers)" class="flex justify-center items-center">
          <div class="mr-2">
            {{ key }}
          </div>
          <div>
            <MoneyInput ref="setupFee" :tier="key" :initValue="tiers[key]"></MoneyInput>
          </div>
        </div>
      </div>
      <div class="mt-4" @click="save">
        <JButton :label="saveText" :isWhite="false"></JButton>
      </div>
    </AdminPanel>
  </div>
</template>

<script>
import JButton from '@/components/JButton'
import AdminPanel from '@/components/AdminPanel'
import MoneyInput from '@/components/MoneyInput'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'ChangeSetupFee',
  components: { AdminPanel, MoneyInput, JButton },
  data () {
    return {
      saveText: 'Save',
      tiers: {}
    }
  },
  async mounted () {
    this.tiers = await this.getSetupFee()
  },
  methods: {
    async getSetupFee () {
      if (Object.keys(this.tiers).length === 0) {
        this.tiers = (await firebase.firestore().doc(`pricing/setup`).get()).data()
      }

      return this.tiers
    },
    async save () {
      this.saveText = 'Saving...'
      for (let tierAndValue of this.$refs.setupFee) {
        let updateObject = {}
        updateObject[tierAndValue.getTier()] = tierAndValue.getValue()
        await firebase.firestore().doc(`pricing/setup`).update(updateObject)
      }
      this.saveText = 'Saved!'
    }
  }
}
</script>
